import LineBarsIcon from 'LuxKit/Icons/line/LineBarsIcon'
import { memo, useCallback, useContext } from 'react'
import { trackClientEvent } from 'analytics/analytics'
import NavBarButton from '../NavBarButton/NavBarButton'
import ModalContext from 'contexts/ModalContext'
import NavBarHamburgerMenu from '../NavBarHamburgerMenu/NavBarHamburgerMenu'
import { closeLoyaltyRewardsNotification } from 'loyalty/components/LoyaltyRewardsNotification'

interface Props {
  className?: string
}

function NavBarDrawerButton(props: Props) {
  const showModal = useContext(ModalContext)

  const onDrawerClick = useCallback(() => {
    closeLoyaltyRewardsNotification()
    trackClientEvent({
      subject: 'hamburger_menu',
      action: 'open',
      category: 'navigation',
      type: 'interaction',
    })
    showModal(<NavBarHamburgerMenu />)
  }, [showModal])

  return <NavBarButton
    {...props}
    icon={<LineBarsIcon />}
    onClick={onDrawerClick}
  />
}

export default memo(NavBarDrawerButton)
